module.exports = "/packs/media/modules/shared/components/RemainingTime/timer-a84c5d81bc5f002f6968b7489e6ded63.svg";